import { downloadZipFileQueryFunction } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipFile/downloadZipFileQueryFunction';
import {
  DownloadZipFileQueryResponseType,
  DownloadZipFileZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipFile/downloadZipFileQuery.type';

import { MutationOptions } from '@tanstack/react-query';

export const downloadZipFileQueryOptions = (): MutationOptions<
  DownloadZipFileQueryResponseType,
  Error,
  DownloadZipFileZipType
> => ({
  mutationKey: ['downloadZipFileQueryOptions'],
  mutationFn: (params: DownloadZipFileZipType) =>
    downloadZipFileQueryFunction({
      id: params.id,
    }),
});
